import React from 'react';
import { func } from 'prop-types';
import { Carousel } from '../../../molecules';
import LuContentItem from '../LuContentItem';
import { reduceToSingleArray } from '../helpers';
import { useLuContentContext } from '../LuContentContext';

const CarouselContent = ({
  onItemClick
}) => {
  const [selected, setSelected] = React.useState(0);
  const {
    data
  } = useLuContentContext();
  const bigArray = reduceToSingleArray(data);
  const topItems = bigArray.filter(item => item.idx === 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Carousel, {
    bg: "background.lighter",
    slidesPerView: 1,
    showPartial: true,
    transitionDuration: 700,
    auto: false,
    showControls: false,
    gutter: 16,
    onChange: active => setSelected(active)
  }, topItems.map(item => /*#__PURE__*/React.createElement(LuContentItem, {
    key: item.id,
    vertical: true,
    data: item,
    onItemClick: onItemClick
  }))), bigArray.filter(item => item.idx !== 0).map(item => {
    const hidden = item.parentIdx !== selected;
    return /*#__PURE__*/React.createElement(LuContentItem, {
      key: item.id,
      data: item,
      hide: hidden,
      dataTestId: hidden ? 'item-hidden' : '',
      cover: true,
      onItemClick: onItemClick
    });
  }));
};

process.env.NODE_ENV !== "production" ? CarouselContent.propTypes = {
  onItemClick: func
} : void 0;
export default CarouselContent;